import React from 'react'
import { Link } from 'react-router-dom'

const Sidebar = () => {



    return (
        <div className="sidebar">
            <ul className="nav flex-column sticky-top pl-0 pt-1 p-3 mt-3" >
                <li className="nav-item mb-2 mt-3">
                    <Link to='/' >
                        <h5>Hii! Admin</h5>
                    </Link>
                </li>
                <li className="nav-item mb-2 ml-3">
                    <Link to='/enquiry' >
                        <i className="fas fa-user font-weight-bold"></i>
                        <span className="ml-3">Enquiries</span>
                    </Link>
                </li>
                <li className="nav-item mb-2 ml-3">
                    <Link to='/contact' >
                        <i className="fas fa-headphones font-weight-bold"></i>
                        <span className="ml-3">Contact</span>
                    </Link>
                </li>

            </ul>
        </div>
    )
}

export default Sidebar